import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import AdminGrid from "../components/AdminGrid";
import "../components/adminDashboard.css";

const AdminDash = AdminGrid;

function AdminDashboardload(props) {
    return (
        <div className="admin-dashboard-page">
            <NavBar page="AdminDashboard" isLoggedIn={true} />

            <main className="dashboard-container">
                <AdminDash />
            </main>

            <Footer />
        </div>
    );
}

export default AdminDashboardload;